import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { ApiResponse, PasswordResetData } from '@shared';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { CookieService } from 'ngx-cookie-service';
@Injectable({ providedIn: 'root' })

/**
 * Auth-service Component
 */
export class AuthenticationService {
  constructor(
    private http: HttpClient,
    private _router: Router,
    private _ngxPermissionService: NgxPermissionsService,
    private cookieService: CookieService,
    private httpBackend: HttpBackend,
  ) {}

  login(email: string, password: string): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/v1/admin/auth/login', { email, password });
  }

  logout() {
    // R14: revoke this admin's tokens on the server first (fire-and-forget). Sent through
    // HttpBackend, i.e. past the interceptors: a stale token must not trigger refresh → logout → …
    const accessToken = this.cookieService.get('accessToken');
    if (accessToken) {
      new HttpClient(this.httpBackend)
        .post(
          `${environment.apiUrl}/v1/admin/auth/logout`,
          {},
          {
            headers: new HttpHeaders({ Authorization: `Bearer ${accessToken}` }),
          },
        )
        .subscribe({ error: () => undefined });
    }
    this.cookieService.delete('accessToken', '/');
    this.cookieService.delete('refreshToken', '/');
    this._ngxPermissionService.flushPermissions();
    this._router.navigateByUrl('/auth/login');
  }

  forgotPassword(email: string): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/v1/admin/auth/forgot-password', { email });
  }

  resetPassword(resetPasswordInformation: PasswordResetData): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/v1/admin/auth/reset-password', resetPasswordInformation);
  }

  getAccessToken(refreshToken: string): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/v1/admin/auth/getAccessToken', { refreshToken });
  }

  getPolicyContent(contentType: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('/v1/admin/auth/policy-content', { params: { contentType } });
  }
}
